import { Component } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent {
  formData = {
    name: '',
    email: '',
    message: ''
  };

  constructor(private firestore: AngularFirestore) {}

  submitForm() {
    if (this.formData.name && this.formData.email && this.formData.message) {
      this.firestore.collection('/contactus').add(this.formData)
        .then(() => {
          alert('Thank you for contacting us!');
          this.formData = { name: '', email: '', message: '' };
        })
        .catch(err => {
          console.error('Error sending message:', err);
        });
    }
  }
}